import Loader from 'components/Loader/styles';
import styled from 'styled-components';

export const Description = styled.div`
  width: 70%;
  margin: 3rem auto;
  p{
    margin: 2rem auto;
    font-size: 1.15rem;
    line-height: 1.4;
    color: ${(props) => props.theme.colors.beige};

    strong{
      color: ${(props) => props.theme.colors.red};
    }
  }
`;

export const Logo = styled.img`
  width: 200px;
  display: block;
  margin: 0 auto 1rem;
`;

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const Container = styled.div`
  width: 40%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${Loader}{
    position: absolute;
    bottom: 50px;
  }

`

export default Container;
